import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import * as authApi from '../../../lib/api/auth';

const BaseCodeSelectbox = (props) => {
  
  const [options, setOptions] = useState([]);
  const { id, value, api, field, name, filterObject } = props;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await authApi.getBaseCode(filterObject);
      if (response.data.list) {
        setOptions(response.data.list);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = async (event) => {
    api.setEditCellValue({ id, field, value: event.target.value }, event);
    // Check if the event is not from the keyboard
    // https://github.com/facebook/react/issues/7407
    // if (event.nativeEvent.clientX !== 0 && event.nativeEvent.clientY !== 0) {
    //   await api.commitCellChange({ id, field });
    //   api.setCellMode(id, field, 'view');
    // }
    // if (event.type === 'click' && event.clientX !== 0 && event.clientY !== 0) {
    //   await api.commitCellChange({ id, field });
    //   api.setCellMode(id, field, 'view');
    // }
  };

  const handleRef = (element) => {
    // console.log(element, 'element');
    if (element) {
      //element.querySelector(`input[value="${value}"]`).focus();
      element.querySelector(`select[name="${name}"] option:checked`);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', pr: 2 }}>
      <TextField
        name={name}
        ref={handleRef}
        select
        value={value}
        onChange={handleChange}
      >
        {/* <MenuItem value=""></MenuItem> */}
        {options &&
          options.map((option) => (
            <MenuItem key={option.revVal2} value={option.revVal2}>
              {option.revVal1}
            </MenuItem>
          ))}
      </TextField>
    </Box>
  );
};

BaseCodeSelectbox.propTypes = {
  /**
   * GridApi that let you manipulate the grid.
   */
  api: PropTypes.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: PropTypes.string.isRequired,
  /**
   * The grid row id.
   */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.string]).isRequired,
  /**
   * The cell value, but if the column has valueGetter, use getValue.
   */
  value: PropTypes.string.isRequired,
};

export default React.memo(BaseCodeSelectbox);
